export class PrintItemDialogController {

    public static $inject: string[] = [
        "$q",
        "$mdDialog",
        "categoryService",
        "rewriteUrlImg",
        "sitesService",
        "utilsService"
    ];

    public images = [];
    public item; // Binded
    public noDealerIcon: string = require("../../../assets/icons/no-dealer-icon.png");
    public field;

    constructor(
        private $q: ng.IQService,
        private $mdDialog: ng.material.IDialogService,
        private categoryService,
        private rewriteUrlImg,
        public sitesService,
        public utilsService
    ) {
        this.field = this.categoryService.getFieldLabel(this.item.category.field);
        this.loadImages()
            .then(() => {
                this._doPrint();
            });
    }

    private loadImages() {
        const deferred = this.$q.defer();

        const rewriteUrlImgParameters = {
            width: 1200,
            height: 900,
            cropMode: "fullFitIn"
        };
        let index = 0;
        const resolveCondition = () => {
            index++;
            if (index === this.item.medias.length) {
                deferred.resolve();
            }
        };

        this.item.medias.forEach(
            media => {
                const img = new Image();

                img.onload = resolveCondition;
                img.onerror = resolveCondition;

                img.src = this.rewriteUrlImg.buildUrl(media.url, rewriteUrlImgParameters);
                this.images.push(img.src);
                rewriteUrlImgParameters.width = 400;
                rewriteUrlImgParameters.height = 200;
            }
        );

        return deferred.promise;
    }

    private _doPrint() {
        // ie-ff exception
        window.onafterprint = this._closeAfterPrint;

        // chrome-safari
        const printHandler = () => {
            this._closeAfterPrint();
        };

        const mql = window.matchMedia("print");
        mql.addListener(printHandler);

        window.print();
    }

    private _closeAfterPrint() {
        if (this.$mdDialog) {
            this.$mdDialog.cancel();
        }
    }
}
